import Cropper from "react-easy-crop";
import { ImageUp, ZoomIn } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api, readableError } from "@/lib/api";

export default function EquipmentImageEditor({ equipment, onClose, onSaved }) {
  const [preview, setPreview] = useState(equipment.image_url);
  const [file, setFile] = useState(null);
  const [crop, setCrop] = useState({ x: equipment.crop_x || 0, y: equipment.crop_y || 0 });
  const [zoom, setZoom] = useState(equipment.crop_zoom || 1);
  const [saving, setSaving] = useState(false);

  const selectFile = (event) => {
    const nextFile = event.target.files?.[0];
    if (!nextFile) return;
    if (!["image/jpeg", "image/png", "image/webp"].includes(nextFile.type) || nextFile.size > 8 * 1024 * 1024) {
      toast.error("Bitte JPG, PNG oder WEBP bis maximal 8 MB auswählen.");
      return;
    }
    setFile(nextFile);
    setPreview(URL.createObjectURL(nextFile));
    setCrop({ x: 0, y: 0 });
    setZoom(1);
  };

  const save = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      let storagePath;
      if (file) {
        const body = new FormData();
        body.append("file", file);
        const upload = await api.post("/admin/uploads/equipment", body);
        storagePath = upload.data.storage_path;
      }
      const response = await api.put(
        `/admin/equipment/${equipment.id}`,
        {
          name: equipment.name,
          category: equipment.category,
          description: equipment.description,
          image_url: equipment.image_url,
          crop_x: Math.max(-100, Math.min(100, crop.x)),
          crop_y: Math.max(-100, Math.min(100, crop.y)),
          crop_zoom: zoom,
        },
        { params: storagePath ? { storage_path: storagePath } : {} },
      );
      onSaved(response.data);
      toast.success("Produktbild aktualisiert.");
      onClose();
    } catch (error) {
      toast.error(readableError(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" data-testid="equipment-image-editor-modal">
      <form className="modal insight-image-editor" onSubmit={save}>
        <button type="button" className="modal-close" onClick={onClose} data-testid="close-equipment-image-editor-button">×</button>
        <p className="eyebrow">PRODUKTBILD ANPASSEN</p>
        <h2>{equipment.name}</h2>
        <label className="image-upload-control" data-testid="equipment-image-upload-label">
          <ImageUp size={18} /> Neues Bild auswählen
          <input type="file" accept="image/jpeg,image/png,image/webp" onChange={selectFile} data-testid="equipment-image-upload-input" />
        </label>
        <div className="crop-stage" data-testid="equipment-crop-stage">
          <Cropper image={preview} crop={crop} zoom={zoom} aspect={1} showGrid onCropChange={setCrop} onZoomChange={setZoom} />
        </div>
        <label className="zoom-control"><ZoomIn size={17} /> Zoom<input type="range" min="1" max="3" step="0.05" value={zoom} onChange={(event) => setZoom(Number(event.target.value))} data-testid="equipment-crop-zoom-input" /></label>
        <p className="crop-hint" data-testid="equipment-crop-hint">Bild im Raster verschieben und mit dem Regler passend zoomen.</p>
        <button className="button button-primary" disabled={saving} data-testid="save-equipment-image-button">{saving ? "Wird gespeichert…" : "Bild übernehmen"}</button>
      </form>
    </div>
  );
}